import { axios } from '@/utils/request'

/**
 * 查询科目管理
 *
 * @author zhangyy
 * @date 2022-05-12 17:56:31
 */
export function baDatadictDetailPage (parameter) {
  return axios({
    url: '/baDatadictDetail/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 备案功能
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function upDataList (parameter) {
  return axios({
    url: '/baDatadictDetail/upLoadJg',
    method: 'get',
    params: parameter
  })
}

/**
 * 科目管理列表
 *
 * @author zhangyy
 * @date 2022-05-12 17:56:31
 */
export function baDatadictDetailList (parameter) {
  return axios({
    url: '/baDatadictDetail/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加科目管理
 *
 * @author zhangyy
 * @date 2022-05-12 17:56:31
 */
export function baDatadictDetailAdd (parameter) {
  return axios({
    url: '/baDatadictDetail/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑科目管理
 *
 * @author zhangyy
 * @date 2022-05-12 17:56:31
 */
export function baDatadictDetailEdit (parameter) {
  return axios({
    url: '/baDatadictDetail/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除科目管理
 *
 * @author zhangyy
 * @date 2022-05-12 17:56:31
 */
export function baDatadictDetailDelete (parameter) {
  return axios({
    url: '/baDatadictDetail/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出科目管理
 *
 * @author zhangyy
 * @date 2022-05-12 17:56:31
 */
export function baDatadictDetailExport (parameter) {
  return axios({
    url: '/baDatadictDetail/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
